import { createFileRoute } from '@tanstack/react-router'

import i18n from '@/i18n'
import { SchoolYearEditView } from '@/modules/schoolSettings'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute(
  '/_auth/school-settings/years/$yearId/edit'
)({
  component: SchoolYearEditView,
  head: () =>
    getMetaWithPageTitle([
      i18n.t('title.edit-school-year', { ns: 'schoolSettings' })
    ])
})
